export enum StepNextMethodEnum {
  None = 0,
  Next = 1,
  PreviewEmailBody = 2,
  Print = 3,
  Send = 4,
}
